<script setup lang="ts">
import { SancareOcticon } from '@sancare/typescript-commons'
import _ from 'lodash'
import { onMounted, onUnmounted, ref } from 'vue'

const props = withDefaults(defineProps<{
  buttonText?: string
  scrollThreshold?: number
}>(), {
  buttonText: 'Haut de page',
  scrollThreshold: 80,
})

const showScrollToTop = ref(false)

function goTopPage() {
  scroll({ top: 0, behavior: 'smooth' })
}
function handleScroll() {
  showScrollToTop.value = window.scrollY > props.scrollThreshold
}

const handleDebouncedScroll = _.debounce(handleScroll, 250)

onMounted(() =>
  window.addEventListener('scroll', handleDebouncedScroll)
)

onUnmounted(() =>
  window.removeEventListener('scroll', handleDebouncedScroll)
)
</script>

<template>
  <div>
    <transition name="simple-fade">
      <div
        v-show="showScrollToTop"
        class="bottom-fixed-button"
        @click="goTopPage"
      >
        <sancare-octicon
          name="chevron-up"
          class="scroll-to-top-button-icon"
          :width="20"
          :height="20"
        />
        {{ buttonText }}
      </div>
    </transition>
  </div>
</template>

<style scoped>
.scroll-to-top-button-icon {
  display: block;
  margin: auto;
}
</style>
